
import { Navbar } from "@/components/Layout/Navbar";
import { Footer } from "@/components/Layout/Footer";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

const Donate = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSignInClick = () => {
    navigate("/auth");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 pt-16">
        <div className="container max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/20 mb-4">
              <Heart className="h-8 w-8 text-red-500" />
            </div>
            <h1 className="text-3xl font-bold mb-4">Support ThePromptSpace</h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
              Help us maintain and improve ThePromptSpace by making a donation. Every contribution counts and allows us to keep providing high-quality AI prompt resources.
            </p>
            
            {!user && (
              <div className="p-4 border rounded-lg bg-muted/50 mb-8">
                <p className="mb-4 text-muted-foreground">
                  Please sign in to make a donation and support our platform.
                </p>
                <Button onClick={handleSignInClick}>Sign In</Button>
              </div>
            )}
          </div>
          
          {user && (
            <div className="grid gap-6 md:grid-cols-3">
              <div className="border rounded-lg p-6 flex flex-col text-center hover:shadow-md transition-shadow">
                <h3 className="text-xl font-semibold mb-2">Basic Support</h3>
                <p className="text-3xl font-bold mb-2">$5</p>
                <p className="text-muted-foreground mb-4 flex-grow">Support basic development and server costs</p>
                <Button>Donate $5</Button>
              </div>
              
              <div className="border rounded-lg p-6 flex flex-col text-center bg-primary/5 border-primary/20 hover:shadow-md transition-shadow">
                <div className="bg-primary/10 text-primary text-sm font-medium py-1 px-3 rounded-full w-fit mx-auto mb-2">
                  Popular
                </div>
                <h3 className="text-xl font-semibold mb-2">Premium Support</h3>
                <p className="text-3xl font-bold mb-2">$10</p>
                <p className="text-muted-foreground mb-4 flex-grow">Help us add new features and improvements</p>
                <Button>Donate $10</Button>
              </div>
              
              <div className="border rounded-lg p-6 flex flex-col text-center hover:shadow-md transition-shadow">
                <h3 className="text-xl font-semibold mb-2">Pro Support</h3>
                <p className="text-3xl font-bold mb-2">$25</p>
                <p className="text-muted-foreground mb-4 flex-grow">Support major platform enhancements</p>
                <Button>Donate $25</Button>
              </div>
            </div>
          )}
          
          {user && (
            <div className="mt-8 text-center">
              <p className="text-muted-foreground mb-2">Want to contribute a custom amount?</p>
              <Button variant="outline">Custom Donation</Button>
            </div>
          )}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Donate;
